module.exports = __webpack_public_path__ + "static/analytics-sku-level-359cdfd64d7da3c417e348c00bdd8b8a.png";